import React from "react";
import { 
  Menu, 
  Drawer, 
  useTheme, 
  useMediaQuery 
} from "@mui/material";
import { HeaderNotificationsBox } from "./notification-box/header-notifications-box";
import { EmailSettingsBox } from "./email-box/email-settings-box";

export const NotificationsMenu = ({ 
  anchorEl,
  open,
  onClose,
  isEmailMenuOpen,
  setIsEmailMenuOpen,
  setIsNotificationsMenuOpen
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const handleMenuClose = () => {
    onClose?.();
  };

  const handleEmailClose = () => {
    setIsEmailMenuOpen(false);
    onClose?.();
  };

  return (
    <>
      {/* Desktop: Notifications Menu (Dropdown) */}
      {!isMobile && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
        >
          <HeaderNotificationsBox
            setIsNotificationsMenuOpen={setIsNotificationsMenuOpen}
            setIsEmailMenuOpen={setIsEmailMenuOpen}
          />
        </Menu>
      )}

      {/* Mobile: Notifications Drawer (Full Screen) */}
      {isMobile && (
        <Drawer
          anchor="right"
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              width: '100%',
              height: '100%',
              maxWidth: '100vw',
              maxHeight: '100vh',
              borderRadius: 0,
              boxShadow: 'none',
              backgroundColor: '#ffffff',
            }
          }}
        >
          <HeaderNotificationsBox
            setIsNotificationsMenuOpen={setIsNotificationsMenuOpen}
            setIsEmailMenuOpen={setIsEmailMenuOpen}
          />
        </Drawer>
      )}

      {/* Email Settings - Use Menu for desktop, Drawer for mobile */}
      {!isMobile && (
        <Menu
          anchorEl={anchorEl}
          open={isEmailMenuOpen}
          onClose={handleEmailClose}
        >
          <EmailSettingsBox setIsEmailMenuOpen={setIsEmailMenuOpen} />
        </Menu>
      )}

      {/* Mobile: Email Settings Drawer */}
      {isMobile && (
        <Drawer
          anchor="right"
          open={isEmailMenuOpen}
          onClose={handleEmailClose}
          PaperProps={{
            sx: {
              width: '100%',
              height: '100%',
              maxWidth: '100vw',
              maxHeight: '100vh',
              borderRadius: 0,
              boxShadow: 'none',
              backgroundColor: '#ffffff',
            }
          }}
        >
          <EmailSettingsBox setIsEmailMenuOpen={setIsEmailMenuOpen} />
        </Drawer>
      )}
    </>
  );
};
